import { API_URL } from 'settings';
import { io } from 'socket.io-client';

export const socket = io(API_URL, {
  transports: ['websocket'],
  autoConnect: false,
});
